export default "__VITE_ASSET__bb56d026__"